import React, { useState,useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import MultiSelect from '../../src/common/MultiSelect';
import { useLanguage } from "../../src/context/LanguageContext";
import secureStorage from "@src/config/encrypt";
import * as HELPER from "../../src/config/helper";
import {OPS_ROLE_ID,MAKER_ROLE_ID,CHECKER_ROLE_ID, MANAGER_LEVEL_IDS} from '../config/constant'
import Select, { components } from 'react-select';
import {filters} from '../config/switch';
import { renderFilterField } from '../component/filter/FilterRenderer';
const { ValueContainer, Placeholder } = components;

const CustomValueContainer = (props: any) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(props.children, (child: any) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

type OptionType = {
  value: string;
  label: string;
};


const RemittanceMoreFilter: React.FC<any> = ({ config, submitHandler, selectedFilters, setSelectedFilters,assignUsers }) => {
    const [isPopupOpen, setPopupOpen] = useState(false);
    const {translations} = useLanguage();
    const [remittance_status , setRemittanceStatus] = useState<any>([]);
    const [userList, setUserList] = useState<any[]>(assignUsers);
    /**
   * FILTER SEARCH HANDLER
   */
    const onFilterSearch = () => {
        submitHandler({ page_number: 1, ...selectedFilters });
        setPopupOpen(false);
    }

    /**
     * FILTER RESET HANDLER
     */
    const onFilterReset = () => {
        setSelectedFilters({});
        submitHandler({ page_number: 1, isResetFilters: true });
        setPopupOpen(false);
    }

    

      /**
    * HANDLE CHANGE FOR SELECTED OPTIONS
  */
  const handleChange = (selectedOption: any, key: string) => {
    let updatedFilters: any = {};
    if (key === 'created_on') {
      // Handle date fields as multiselect (range or single)
        if (selectedOption.length === 2) {
            updatedFilters[`${key}_from`] = selectedOption[0] ? selectedOption[0].format("YYYY-MM-DD") : null;
            updatedFilters[`${key}_to`] = selectedOption[1] ? selectedOption[1].format("YYYY-MM-DD") : null;
        } else {
            updatedFilters[`${key}_from`] = selectedOption[0]?.format("YYYY-MM-DD");
            updatedFilters[`${key}_to`] = null;
        }
    }else if (selectedOption instanceof Array) {
      // For multi-select (array of options)
      updatedFilters[key] = selectedOption.map((e) => e.value);
    }else if (key === 'user_filter_type') {
        updatedFilters[key] = selectedOption?.value || null;
        updatedFilters['assign_user_id'] = null;
    }else {
      // For single select
      updatedFilters[key] = selectedOption?.value || null;
    }
    setSelectedFilters((prev: any) => ({
      ...prev, // keep old filters
      ...updatedFilters, // merge new filters
    }));
  };

   useEffect(() => {
        if (config?.remittance_status) {
            const authUserInfo = secureStorage.getItem("authUserInfo");
            const roleId = authUserInfo?.user_data?.assigned_role_ids;
            const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name);
            let filteredData: any[] = [];
            switch (roleName) {
                case "REM_OPS":
                case "REM_FINANCE_MAKER":
                case "REM_FINANCE_CHECKER":
                    // show only records matching user's role
                    filteredData = config.remittance_status.filter((item: any) => item.role_id === roleId);
                    break;
                default:
                    filteredData = config.remittance_status.map((item: any) => {
                        let newLabel = item.label;
                        if (item.role_id === OPS_ROLE_ID && item.label === "Ready") {
                            newLabel = "Ready - Ops";
                        } else if (item.role_id === MAKER_ROLE_ID && item.label === "Ready") {
                            newLabel = "Ready - Maker";
                        } else if (item.role_id === CHECKER_ROLE_ID && item.label === "Ready") {
                            newLabel = "Ready - Checker";
                        }
                        return { ...item, label: newLabel };
                    });
                break;
            }
            setRemittanceStatus(filteredData);
        }
    }, [config])

    const authUserInfo = secureStorage.getItem("authUserInfo");
    const filterConfig = filters.remittanceMoreFilters(translations)

    useEffect(() => {
        if (selectedFilters?.user_filter_type) {
            const filtered = assignUsers.filter((user: any) => +user.role_id === +selectedFilters.user_filter_type);
            setUserList(filtered);
        } else {
            setUserList(assignUsers); // reset when role cleared / unassigned
        }
    }, [selectedFilters?.user_filter_type, assignUsers]);

    return (
        <div className="filter-option">
            <Dropdown show={isPopupOpen} onToggle={(isOpen: any) => setPopupOpen(isOpen)}>
                <div className="text-btn d-flex">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                        <span className="more-filter-txt">More Filters</span>
                        <span className="leass-filter-txt">Less Filters</span>
                    </Dropdown.Toggle>

                    <div className="btn-submit-reset top-btn-none">
                        <button className="btn-primary" onClick={onFilterSearch}>Search</button>
                        <button className="btn-reset" onClick={onFilterReset}>Reset</button>
                    </div>
                </div>

                <Dropdown.Menu>
                    <div className="more-filter-option">
                        <h3>More Filters</h3>
                        <div className="filter-form">
                            {filterConfig.map((filter:any) =>
                                renderFilterField(filter, { selectedFilters, handleChange, translations, authUserInfo, CustomValueContainer,
                                    options: { 
                                        lead_types:config?.lead_types,
                                        remittance_type: config?.remittance_type,
                                        remittance_status: remittance_status,
                                        assigning_filters: config?.assigning_filters,
                                        assign_user_id:userList,
                                        user_filter_type:config?.remittance_roles,
                                        payout_payment_status:config?.payment_status
                                    }
                                })
                            )}
                            {/* <fieldset className="single-select">
                                <div  className="material">
                                    <MultiSelect
                                    isSelectAll={true}
                                    options={config['lead_types']}
                                    placeholder={translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['SORUCE_TYPE'] || translations.commonMsg?.loading}
                                    value={
                                        (config['lead_types'] instanceof Array &&
                                        selectedFilters?.source &&
                                        config['lead_types'].filter((e: any) =>
                                            [...(selectedFilters?.source instanceof Array ? selectedFilters?.source : [])].includes(e.value)
                                        )) || []
                                    }
                                    onChange={(e: any) => handleChange(e, 'source')}
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    />
                                </div>
                            </fieldset>

                            <fieldset className="single-select">
                                <div  className="material">
                                    <MultiSelect
                                    isSelectAll={true}
                                    options={config["remittance_type"]}
                                    placeholder={translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['REMITTANCE_TYPE'] || translations.commonMsg?.loading}
                                    value={
                                        (config["remittance_type"] instanceof Array &&
                                        Array.isArray(selectedFilters?.remittance_type) &&
                                        config["remittance_type"].filter((e: any) =>
                                            [...(selectedFilters?.remittance_type instanceof Array ? selectedFilters?.remittance_type : [])].includes(e.value)
                                        )) || []
                                    }
                                    onChange={(e: any) => handleChange(e, 'remittance_type')}
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    />
                                </div>
                            </fieldset>

                            <fieldset className="single-select">
                                <div className="material">
                                    <MultiSelect
                                    isSelectAll={true}
                                    options={remittance_status}
                                    placeholder={translations.Remittance?.["REMITTANCE_TABLE_FILTER"]['REMITTANCE_STATUS'] || translations.commonMsg?.loading}
                                    value={
                                        Array.isArray(selectedFilters?.status)
                                        ? remittance_status.filter((e: any) =>
                                            selectedFilters.status.includes(e.value)
                                            )
                                        : []
                                    }
                                    onChange={(e: any) => handleChange(e, 'status')}
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    />
                                </div>
                            </fieldset>
                            {
                             MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) && (
                                <fieldset className="single-select">
                                    <div className="material">
                                    <Select<OptionType>
                                        components={{ ValueContainer: CustomValueContainer }}
                                        options={config?.assigning_filters}
                                        placeholder="Assignment Status"
                                        className="react-select"
                                        classNamePrefix="react-select"
                                        isClearable
                                        onChange={(e: any) => handleChange(e, 'assignment_status')}
                                        value={config?.assigning_filters?.find((option: any) => option.value === selectedFilters.assignment_status) || null}
                                    />
                                    </div>
                                </fieldset>
                             )
                            } */}

                            <div className="btn-submit-reset more-filter-btn">
                                <button className="btn-primary" onClick={onFilterSearch}>Search</button>
                                <button className="btn-reset" onClick={onFilterReset}>Reset</button>
                            </div>
                        </div>
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default RemittanceMoreFilter;
